import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../MovieCard/style.css';

const MovieCard = ({ movie, setWatchList, watchList = [] }) => {
  useEffect(() => {
    localStorage.setItem('watchList', JSON.stringify(watchList));
  }, [watchList]);

  if (!movie) return null;

  const watchListIds = watchList.map((item) => item.id);

  const addToFavourite = (movie) => {
    if (watchListIds.includes(movie.id)) {
      alert('Movie already added to your watchlist');
    } else {
      setWatchList([...watchList, movie]);
    }
  };

  const deleteFromWatchList = (id) => {
    setWatchList(watchList.filter((item) => item.id !== id));
  };

  const releaseDate = movie.releaseDate ? new Date(movie.releaseDate).toLocaleDateString() : 'N/A';

  return (
    <div className='single-movie'>
      <div className='movie-poster'>
        <img
          src={movie.thumbnailUrl || 'https://via.placeholder.com/300x450?text=No+Image'}
          alt={`${movie.title} poster`}
        />

        {/* Overlay nội dung phim hiển thị luôn */}
        <div className='movie-content-overlay'>
          <div className='movie-content'>
            <div className='top row'>
              <h5 className='title'>
                <Link className='link' to={`/movie/${movie.id}`}>
                  {movie.title.length > 18
                    ? movie.title.slice(0, 18) + '...'
                    : movie.title}
                </Link>
              </h5>
              <h6 className='year'>{releaseDate}</h6>
            </div>
            <div className='genres'>
              {(movie.genres && movie.genres.length > 0)
                ? movie.genres.map((g) => (
                  <span key={g} className='genre-tag'>{g}</span>
                ))
                : <span className='genre-tag unknown'>Unknown</span>
              }
            </div>
            <p className='director'><strong>Director:</strong> {movie.director || 'Unknown'}</p>
            <p className='duration'><strong>Duration:</strong> {movie.duration ? `${movie.duration} min` : 'N/A'}</p>
          </div>
        </div>

        {/* Nút chỉ hiển thị khi hover */}
        <div className='movie-overlay-hover'>
          <ul className='overlay-btns'>
            {watchListIds.includes(movie.id) ? (
              <li>
                <button
                  className='btn watch-btn'
                  onClick={() => deleteFromWatchList(movie.id)}
                >
                  Gỡ xem sau
                </button>
              </li>
            ) : (
              <li>
                <button
                  className='btn watch-btn'
                  onClick={() => addToFavourite(movie)}
                >
                  Xem sau
                </button>
              </li>
            )}
            <li>
              <Link className='btn details-btn' to={`/movie/${movie.id}`}>
                Chi tiết phim
              </Link>
            </li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default MovieCard;
